var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 27 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m24.07 25.875-8.97-8.93a8.5 8.5 0 0 1-2.455 1.346 8.7 8.7 0 0 1-2.954.496q-3.88 0-6.566-2.675Q.437 13.436.437 9.572t2.688-6.54Q5.812.358 9.691.358t6.567 2.676q2.685 2.676 2.686 6.54 0 1.56-.498 2.94a8.4 8.4 0 0 1-1.352 2.446l8.968 8.932zM9.69 15.952q2.67 0 4.54-1.86 1.867-1.862 1.867-4.52t-1.868-4.52q-1.87-1.86-4.538-1.86-2.67 0-4.539 1.86-1.867 1.862-1.867 4.52t1.867 4.52q1.87 1.86 4.539 1.86"
  })));
};
export default SvgSearch;